module.exports = __webpack_public_path__ + "static/media/report-extractor.6af4db61.png";